import React, { useContext, useEffect, useState, useRef } from "react";
import { AppContext } from "../../components/States/AppContext";

// components
import TopBar from "../../components/MonitorComponents/TopBar";
import MessageBox from "../../components/MonitorComponents/MessageBox";
import PatientDemo from "../../components/MonitorComponents/PatientDemo";
import HrButton from "../../components/MainButtons/HrButton";
import PVC from "../../components/MainButtons/PVC";
import { Qtc2 } from "../../components/MainButtons/Qtc2";
import StButton from "../../components/MainButtons/StButton";

import multileadwaves from "../../img/waveforms/landscape/new/mulltileadwaves.mp4";

// styles
import {
  ColumnWaves,
  LandScapeContainer,
  Landscapeflex2,
  ScrollBox,
  BlackBox,
  NumericOverlay,
} from "./LandScapePage.elements";
import VideoPlayer from "../../components/Common/VideoPlayer";

const LandscapeMultiLead = () => {
  const { state, setState } = useContext(AppContext);

  return (
    <LandScapeContainer>
      <TopBar />
      {/* <MessageBox style={{ height: "100px" }} /> */}
      <MessageBox landscape />
      <PatientDemo />
      <NumericOverlay></NumericOverlay>
      <Landscapeflex2>
        <HrButton />
        <StButton />
        <PVC />
        <Qtc2 />
      </Landscapeflex2>
      {!state.ecg && <BlackBox />}
      <ColumnWaves multilead>
        {state.ecg === false ? (
          <div
            style={{
              background: "black",

              width: "100%",
              height: "51%",
              position: "absolute",
            }}
          ></div>
        ) : (
          <ScrollBox>
            <VideoPlayer
              src={multileadwaves}
              autoPlay
              playsInline
              loop
              muted
              loading="eager"
              style={{
                width: "101%",
                margin: 0,
                marginTop: "-.1em",
              }}
            ></VideoPlayer>
            {/* <video
              disablePictureInPicture
              src={multileadwaves}
              autoPlay
              playsInline
              loop
              muted
              loading="eager"
              // style={{ marginTop: "-.1em", scale:".99" }}
              style={{ marginTop: "-.1em", backgroundColor: "red" }}
            /> */}
          </ScrollBox>
        )}
      </ColumnWaves>
    </LandScapeContainer>
  );
};

export default LandscapeMultiLead;
